// Custom scripts
import Login from './login';
import DaneDoFaktur from './dane-do-faktur';
import PopupAadresDostawy from './popup-adres-dostawy';
import PopupDaneDoFakturyVat from './popup-dane-do-faktury-vat';
import PopupZmienHaslo from './popup-zmien-haslo';


(() => {
    if (typeof $ === 'undefined') {
        throw new TypeError('... requires jQuery.');
    }

    $(document).ready(() => {
        const login = new Login();
        const daneDoFaktur = new DaneDoFaktur();
        const popupAadresDostawy = new PopupAadresDostawy();
        const popupDaneDoFakturyVat = new PopupDaneDoFakturyVat();
        const popupZmienHaslo = new PopupZmienHaslo();

        login.init();
        daneDoFaktur.init();
        popupAadresDostawy.init();
        popupDaneDoFakturyVat.init();
        popupZmienHaslo.init();
    });

})();
